
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const CashierRoute = ({ children }) => {
    const { currentUser, userData, loading } = useAuth();

    if (loading) {
        return <div className="loading-fullscreen">Loading...</div>;
    }

    if (!currentUser) {
        return <Navigate to="/login" replace />;
    }

    if (!userData) {
        return <div className="loading-fullscreen">Loading user data...</div>;
    }

    if (userData.role?.toLowerCase() !== 'cashier') {
        return <Navigate to="/unauthorized" replace />;
    }

    return <>{children}</>;
};

export default CashierRoute;
